import axios from 'axios';
import ApiService from './ApiService';
import {
  IBookingEvent,
  IFetchSenderAvailabilityData,
  IListSenderAvailability,
} from 'modules/booking/interfaces';
import { IPaginatedCommon } from 'modules/pos-settings/interfaces/common';
import { INamedEntity } from 'common/interfaces/common';
import { ICalendarSharingParams } from 'modules/booking/containers/BookingShared/useCalendarSharingParams';

export default class BookingService extends ApiService {
  public getEventServices = (search: string): Promise<INamedEntity[]> => {
    return axios.get('/api/v1/events/services', { params: { title: search } });
  };

  public getSharingEvents = (
    corporationId: string,
    search: ICalendarSharingParams,
  ): Promise<IPaginatedCommon<IBookingEvent>> => {
    return axios.get(`/api/v1/corporations/${corporationId}/calendar-sharing/events`, {
      params: search,
    });
  };

  public getSharingEventByIdAndTime = (
    corporationId: string,
    eventId: string,
    eventTime: string,
  ): Promise<IBookingEvent> =>
    axios.get(`/api/v1/corporations/${corporationId}/calendar-sharing/events/${eventId}`, {
      params: { eventStartDate: eventTime },
    });

  public getSenderAvailability = async ({
    events = [],
  }: IFetchSenderAvailabilityData = {}): Promise<IListSenderAvailability> => {
    return axios.get('/api/v1/sender-availability', {
      params: { types: events.join(',') },
    });
  };
}
